import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import FarmApiService from 'services/farmApiServices'
import { IFarmStatistics } from '../models/IFarm'

interface FarmState {
	statistics: IFarmStatistics | null
	loading: boolean
	error: any
}

const initialState: FarmState = {
	statistics: null,
	loading: false,
	error: null,
}
export const fetchFarmStatistics = createAsyncThunk<
	IFarmStatistics,
	void,
	{ rejectValue }
>('farm/fetchStatistics', async function (_, { rejectWithValue }) {
	try {
		const response = await FarmApiService.getFarmStatistic()
		if (response.status !== 200) {
			throw response
		}
		return response.data
	} catch (error) {
		console.error('API Error:', error.response?.status, error.response?.data)

		return rejectWithValue({
			status: error.response?.status,
			data: error.response?.data,
		})
	}
})

export const farmSlice = createSlice({
	name: 'farm',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(
				fetchFarmStatistics.fulfilled,
				(state, action: PayloadAction<IFarmStatistics>) => {
					state.loading = false
					state.error = null
					state.statistics = action.payload
				},
			)
			.addCase(fetchFarmStatistics.pending, state => {
				state.loading = true
				state.error = null
				state.statistics = null
			})
			.addCase(fetchFarmStatistics.rejected, (state, action: PayloadAction) => {
				state.loading = false
				state.error = action.payload
				state.statistics = null
			})
	},
})

export default farmSlice.reducer
